
var pf_config = require('../pf_config.json');
var Cookies = require('js-cookie');

export const user = (state = {
  isLoggedIn: false,
  token: undefined,
  billingStatus: {},
  invoice: {},
  pastInvoices: [],
  paymentMethods: [],
  pendingInvites: [],
  roles: { trial: true },
  settings: {},
  registerForm:           {errors: {}, lastSubmit: {}},
  loginForm:              {errors: {}, lastSubmit: {}},
  changePasswordForm:     {errors: {}, lastSubmit: {}},
  updateMFAForm:          {errors: {}, lastSubmit: {}},
  updateUserInfoForm:     {errors: {}, lastSubmit: {}},
  emailForm:              {errors: {}, lastSubmit: {}},
  recoverForm:            {errors: {}, lastSubmit: {}},
  deleteAccountForm:      {errors: {}, lastSubmit: {}},
  upgradeToProForm:       {errors: {}, lastSubmit: {}},
  cancelProForm:          {errors: {}, lastSubmit: {}},
  reportBugForm:          {errors: {}, lastSubmit: {}},
  confirmEmailLoginForm:  {errors: {}, lastSubmit: {}},
  resetPasswordForm:      {errors: {}, lastSubmit: {}},
  updateUserDefaultSettingsForm: {errors: {}, lastSubmit: {}},
  updateUserDefaultWorkspaceForm: {errors: {}, lastSubmit: {}},
  createUserStripePortalSessionForm: {errors: {}, lastSubmit: {}},
  createUserStripeCheckoutSessionForm: {errors: {}, lastSubmit: {}},
  paymentMethodsFormError: false

}, action) => {

  switch(action.type){
    case 'LOGOUT':
      Cookies.remove(process.env.REACT_APP_COOKIE_AUTH);
      Cookies.remove(process.env.REACT_APP_CURRENT_TEAM);
      window.location.replace('/');
      return {
        ...state,
        token: undefined,
        id: undefined,
        display_name: undefined,
        email: undefined,
        roles: { trial: true },
        employee: undefined,
        tryingToLogin: false,
        isLoggedIn: false
      }

    case 'REQUEST_REGISTER':
      return {
        ...state,
        tryingToRegister: true,
        registerForm: {errors: {}, lastSubmit: action.data.lastSubmit}
      }

    case 'RECEIVE_REGISTER_FAIL':
       return {
        ...state,
        tryingToRegister: false,
        failedToRegister: new Date().getTime(),
        registerForm: {errors: action.data.errors, lastSubmit: action.data.lastSubmit}
      }

    case 'RECEIVE_REGISTER_SUCCESS':

       // Cookies.set(process.env.REACT_APP_COOKIE_AUTH, action.data.token);
       return {
        ...state,
        tryingToRegister: false,
        successfullyRegistered: new Date().getTime(),
        isLoggedIn: true,
        email: action.data.email,
        id: action.data.id,
        teams: action.data.teams,
        roles: action.data.roles || {trial: true},
        employee: action.data.employee,
        display_name: action.data.display_name,
        registerForm: {errors: {}, lastSubmit: {}}
      }



    case 'REQUEST_LOGIN':
      return {
        ...state,
        tryingToLogin: true,
        loginForm: {errors: {}, lastSubmit: action.data.lastSubmit}
      }

    case 'RECEIVE_LOGIN_FAIL':
       return {
        ...state,
        tryingToLogin: false,
        failedToLogin: new Date().getTime(),
        loginForm: {errors: action.data.errors, lastSubmit: action.data.lastSubmit}
      }

    case 'RECEIVE_LOGIN_SUCCESS':

       // Cookies.set(process.env.REACT_APP_COOKIE_AUTH, action.data.token);
       // console.log(action.data.roles);
       return {
        ...state,
        tryingToLogin: false,
        successfullyLoggedIn: new Date().getTime(),
        isLoggedIn: true,
        email: action.data.email,
        id: action.data.id,
        teams: action.data.teams,
        roles: action.data.roles || {trial: true},
        employee: action.data.employee,
        display_name: action.data.display_name,
        delinquent: action.data.delinquent,
        loginForm: {errors: {}, lastSubmit: {}}
      }

    case 'RECEIVE_LOGIN_MFA_PROMPT':

      return {
        ...state,
        tryingToLogin: false,
        mfa: true,
        mfa_email_enabled: action.data.mfa_email_enabled,
        mfa_app_enabled: action.data.mfa_app_enabled,
      }


    case 'REQUEST_LOGIN_MFA':
      return {
        ...state,
        tryingToLoginMFA: true,
        loginMFAForm: {errors: {}, lastSubmit: action.data.lastSubmit}
      }

    case 'RECEIVE_LOGIN_MFA_FAIL':
       return {
        ...state,
        tryingToLoginMFA: false,
        failedToLoginMFA: new Date().getTime(),
        loginMFAForm: {errors: action.data.errors, lastSubmit: action.data.lastSubmit}
      }

    case 'RECEIVE_LOGIN_MFA_SUCCESS':

       return {
        ...state,
        tryingToLoginMFA: false,
        successfullyLoggedInMFA: new Date().getTime(),
        loginMFAForm: {errors: {}, lastSubmit: {}}
      }

    case 'REQUEST_SEND_LOGIN_MFA_EMAIL':
      return {
        ...state,
        tryingToSendLoginMFAEmail: true,
        loginMFAForm: {errors: {}, lastSubmit: action.data.lastSubmit}
      }

    case 'RECEIVE_SEND_LOGIN_MFA_EMAIL_FAIL':
       return {
        ...state,
        tryingToSendLoginMFAEmail: false,
        failedToSendLoginMFAEmail: new Date().getTime()
      }

    case 'RECEIVE_SEND_LOGIN_MFA_EMAIL_SUCCESS':

       return {
        ...state,
        tryingToSendLoginMFAEmail: false,
        successfullySentLoginMFAEmail: new Date().getTime(),
        lastSentMFAEmail: action.data.emailSentAt
      }


    case 'SAVE_TOKEN':

      var parsed_token = JSON.parse(window.atob(action.data.split('.')[1]));

      return {
        ...state, 
        token: token,
        id: parsed_token.id,
        teams: parsed_token.teams,
        roles: parsed_token.roles || {trial: true},
        employee: parsed_token.employee,
        display_name: parsed_token.display_name, 
        email: parsed_token.email,
        email_verified: parsed_token.email_verified,
        settings: parsed_token.settings || {},
        isLoggedIn: true
      }

    case 'REQUEST_PASSWORD_CHANGE':
      return {
        ...state,
        tryingToChangePassword: true,
        changePasswordForm: {errors: {}, lastSubmit: action.data.lastSubmit}
      }

    case 'RECEIVE_PASSWORD_CHANGE_FAIL':
       return {
        ...state,
        tryingToChangePassword: false,
        failedToChangedPassword: new Date().getTime(),
        changePasswordForm: {errors: action.data.errors, lastSubmit: action.data.lastSubmit}
      }

    case 'RECEIVE_PASSWORD_CHANGE_SUCCESS':
       return {
        ...state,
        tryingToChangePassword: false,
        successfullyChangedPassword: new Date().getTime(),
        changePasswordForm: {errors: {}, lastSubmit: {}}
      }



    case 'REQUEST_UPDATE_USER_INFO':
      return {
        ...state,
        tryingToUpdateUserInfo: true,
        updateUserInfoForm: {errors: {}, lastSubmit: action.data.lastSubmit}
      }

    case 'RECEIVE_UPDATE_USER_INFO_FAIL':
       return {
        ...state,
        tryingToUpdateUserInfo: false,
        failedToUpdateUserInfo: new Date().getTime(),
        updateUserInfoForm: {errors: action.data.errors, lastSubmit: action.data.lastSubmit}
      }

    case 'RECEIVE_UPDATE_USER_INFO_SUCCESS':

       // Cookies.set(process.env.REACT_APP_COOKIE_AUTH, action.data.token);
       var parsed_token = JSON.parse(window.atob(action.data.token.split('.')[1]));
       return {
        ...state,
        tryingToUpdateUserInfo: false,
        successfullyUpdatedUserInfo: new Date().getTime(),
        isLoggedIn: true,
        email: parsed_token.email,
        email_verified: parsed_token.email_verified,
        id: parsed_token.id,
        teams: parsed_token.teams,
        roles: parsed_token.roles || {trial: true},
        employee: action.data.employee,
        display_name: parsed_token.display_name,
        updateUserInfoForm: {errors: {}, lastSubmit: {}},
        delinquent: action.data.delinquent
      }


    case 'REQUEST_UPDATE_USER_DEFAULT_SETTINGS':
      return {
        ...state,
        tryingToUpdateUserDefaultSettings: true,
        updateUserDefaultSettingsForm: {errors: {}, lastSubmit: action.data.lastSubmit}
      }

    case 'RECEIVE_UPDATE_USER_DEFAULT_SETTINGS_FAIL':
      return {
        ...state,
        tryingToUpdateUserDefaultSettings: false,
        failedToUpdateUserDefaultSettings: new Date().getTime(),
        updateUserDefaultSettingsForm: {errors: action.data.errors, lastSubmit: action.data.lastSubmit}
      }

    case 'RECEIVE_UPDATE_USER_DEFAULT_SETTINGS_SUCCESS':

      var parsed_token = JSON.parse(window.atob(action.data.token.split('.')[1]));
      return {
        ...state,
        tryingToUpdateUserDefaultSettings: false,
        successfullyUpdatedUserDefaultSettings: new Date().getTime(),
        settings: parsed_token.settings,
        updateUserDefaultWorkspaceForm: {errors: {}, lastSubmit: {}},
      }


    case 'REQUEST_UPDATE_USER_DEFAULT_WORKSPACE':
      return {
        ...state,
        tryingToUpdateUserDefaultWorkspace: true,
        updateUserDefaultWorkspaceForm: {errors: {}, lastSubmit: action.data.lastSubmit}
      }

    case 'RECEIVE_UPDATE_USER_DEFAULT_WORKSPACE_FAIL':
      return {
        ...state,
        tryingToUpdateUserDefaultWorkspace: false,
        failedToUpdateUserDefaultWorkspace: new Date().getTime(),
        updateUserDefaultWorkspaceForm: {errors: action.data.errors, lastSubmit: action.data.lastSubmit}
      }

    case 'RECEIVE_UPDATE_USER_DEFAULT_WORKSPACE_SUCCESS':

      var parsed_token = JSON.parse(window.atob(action.data.token.split('.')[1]));
      return {
        ...state,
        tryingToUpdateUserDefaultWorkspace: false,
        successfullyUpdatedUserDefaultWorkspace: new Date().getTime(),
        settings: parsed_token.settings,
        updateUserDefaultWorkspaceForm: {errors: {}, lastSubmit: {}},
      }



    case 'REQUEST_UPDATE_EMAIL':
      return {
        ...state,
        tryingToUpdateEmail: true,
        emailForm: {errors: {}, lastSubmit: action.data.lastSubmit}
      }

    case 'RECEIVE_UPDATE_EMAIL_FAIL':
       return {
        ...state,
        tryingToUpdateEmail: false,
        failedToUpdateEmail: new Date().getTime(),
        emailForm: {errors: action.data.errors, lastSubmit: action.data.lastSubmit}
      }

    case 'RECEIVE_UPDATE_EMAIL_SUCCESS':

       // Cookies.set(process.env.REACT_APP_COOKIE_AUTH, action.data.token);
       parsed_token = JSON.parse(window.atob(action.data.token.split('.')[1]));
       return {
        ...state,
        tryingToUpdateEmail: false,
        successfullyUpdatedEmail: new Date().getTime(),
        isLoggedIn: true,
        email: parsed_token.email,
        email_verified: parsed_token.email_verified,
        public_email: action.data.public_email,
        id: parsed_token.id,
        teams: parsed_token.teams,
        roles: parsed_token.roles || {trial: true},
        employee: action.data.employee,
        display_name: parsed_token.display_name,
        delinquent: action.data.delinquent,
        emailForm: {errors: {}, lastSubmit: {}}
      }


    case 'REQUEST_RESEND_VERIFICATION_EMAIL':
      return {
        ...state,
        tryingToResendVerificationEmail: true
      }

    case 'RECEIVE_RESEND_VERIFICATION_EMAIL_FAIL':
       return {
        ...state,
        tryingToResendVerificationEmail: false,
        failedToResendVerificationEmail: new Date().getTime(),
      }

    case 'RECEIVE_RESEND_VERIFICATION_EMAIL_SUCCESS':

       return {
        ...state,
        tryingToResendVerificationEmail: false,
        successfullyResentVerificationEmail: new Date().getTime()
      }

    case 'REQUEST_MY_ACCOUNT_INFO':
      return {
        ...state,
        tryingToFetchMyAccountInfo: true
      }

    case 'RECEIVE_MY_ACCOUNT_INFO_FAIL':
       return {
        ...state,
        tryingToFetchMyAccountInfo: false
      }

    case 'RECEIVE_MY_ACCOUNT_INFO_SUCCESS':

       return {
        ...state,
        tryingToFetchMyAccountInfo: false,
        isLoggedIn: true,
        email: action.data.email,
        public_email: action.data.public_email,
        roles: action.data.roles || {trial: true},
        employee: action.data.employee,
        email_verified: action.data.email_verified,
        id: action.data.id,
        teams: action.data.teams,
        display_name: action.data.display_name,
        stripe_customer_id:action.data.stripe_customer_id,
        trial_end: action.data.trial_end,
        delinquent: action.data.delinquent,
        mfa_app_enabled: action.data.mfa_app_enabled,
        mfa_email_enabled: action.data.mfa_email_enabled,
        settings: action.data.settings || {}
      }


    case 'REQUEST_MY_PENDING_INVITES':
      return {
        ...state,
        tryingToFetchMyPendingInvites: true
      }

    case 'RECEIVE_MY_PENDING_INVITES_FAIL':
       return {
        ...state,
        tryingToFetchMyPendingInvites: false,
        pendingInvites: []
      }

    case 'RECEIVE_MY_PENDING_INVITES_SUCCESS':

       return {
        ...state,
        tryingToFetchMyPendingInvites: false,
        pendingInvites: action.data
      }


    case 'REQUEST_SETUP_EMAIL_MFA':
      return {
        ...state,
        tryingToSetupEmailMFA: true
      }

    case 'RECEIVE_SETUP_EMAIL_MFA_FAIL':
       return {
        ...state,
        failedToSetupEmailMFA: new Date().getTime(),
        tryingToSetupEmailMFA: false
      }

    case 'RECEIVE_SETUP_EMAIL_MFA_SUCCESS':

       return {
        ...state,
        tryingToSetupEmailMFA: false,
        successfullySetupEmailMFA: new Date().getTime(),
      }


    case 'REQUEST_ENABLE_EMAIL_MFA':
      return {
        ...state,
        tryingToEnableEmailMFA: true
      }

    case 'RECEIVE_ENABLE_EMAIL_MFA_FAIL':
       return {
        ...state,
        failedToEnableEmailMFA: new Date().getTime(),
        tryingToEnableEmailMFA: false
      }

    case 'RECEIVE_ENABLE_EMAIL_MFA_SUCCESS':

       return {
        ...state,
        tryingToEnableEmailMFA: false,
        mfa_email_enabled: true,
        successfullyDisabledEmailMFA: 0,
        successfullyEnabledEmailMFA: new Date().getTime(),
      }

    case 'REQUEST_DISABLE_EMAIL_MFA':
      return {
        ...state,
        tryingToDisableEmailMFA: true
      }

    case 'RECEIVE_DISABLE_EMAIL_MFA_FAIL':
       return {
        ...state,
        failedToDisableEmailMFA: new Date().getTime(),
        tryingToDisableEmailMFA: false
      }

    case 'RECEIVE_DISABLE_EMAIL_MFA_SUCCESS':

       return {
        ...state,
        tryingToDisableEmailMFA: false,
        mfa_email_enabled: false,
        successfullyEnabledEmailMFA: 0,
        successfullyDisabledEmailMFA: new Date().getTime(),
      }

    case 'REQUEST_SETUP_APP_MFA':
      return {
        ...state,
        tryingToSetupAppMFA: true
      }

    case 'RECEIVE_SETUP_APP_MFA_FAIL':
       return {
        ...state,
        failedToSetupAppMFA: new Date().getTime(),
        tryingToSetupAppMFA: false
      }

    case 'RECEIVE_SETUP_APP_MFA_SUCCESS':

       return {
        ...state,
        mfa_qr_code_url: action.data.url,
        tryingToSetupAppMFA: false,
        successfullySetupAppMFA: new Date().getTime(),
      }


    case 'REQUEST_ENABLE_APP_MFA':
      return {
        ...state,
        tryingToEnableAppMFA: true
      }

    case 'RECEIVE_ENABLE_APP_MFA_FAIL':
       return {
        ...state,
        failedToEnableAppMFA: new Date().getTime(),
        tryingToEnableAppMFA: false
      }

    case 'RECEIVE_ENABLE_APP_MFA_SUCCESS':

       return {
        ...state,
        tryingToEnableAppMFA: false,
        mfa_qr_code_url: false,
        mfa_app_enabled: true,
        successfullyDisabledAppMFA: 0,
        successfullyEnabledAppMFA: new Date().getTime(),
      }


    case 'REQUEST_DISABLE_APP_MFA':
      return {
        ...state,
        tryingToDisableAppMFA: true
      }

    case 'RECEIVE_DISABLE_APP_MFA_FAIL':
       return {
        ...state,
        failedToDisableAppMFA: new Date().getTime(),
        tryingToDisableAppMFA: false
      }

    case 'RECEIVE_DISABLE_APP_MFA_SUCCESS':

       return {
        ...state,
        tryingToDisableAppMFA: false,
        mfa_qr_code_url: false,
        mfa_app_enabled: false,
        successfullyEnabledAppMFA: 0,
        successfullyDisabledAppMFA: new Date().getTime(),
      }

    case 'REQUEST_RECOVER_ACCOUNT':
      return {
        ...state,
        tryingToRecoverAccount: true,
        recoverAccountSent: false,
        recoverForm: {errors: {}, lastSubmit: action.data.lastSubmit || {}}
      }

    case 'RECEIVE_RECOVER_ACCOUNT_FAIL':
       return {
        ...state,
        tryingToRecoverAccount: false,
        failedToRecoverAccount: new Date().getTime(),
        recoverForm: {errors: action.data.errors, lastSubmit: action.data.lastSubmit || {}}
      }

    case 'RECEIVE_RECOVER_ACCOUNT_SUCCESS':

       return {
        ...state,
        tryingToRecoverAccount: false,
        successfullyRecoveredAccount: new Date().getTime(),
        recoverAccountSent: true,
        recoverForm: {errors: {}, lastSubmit: action.data.lastSubmit || {}}
      }



    case 'REQUEST_DELETE_ACCOUNT':
      return {
        ...state,
        tryingToDeleteAccount: true,
        deleteAccountForm: {errors: {}, lastSubmit: action.data.lastSubmit}
      }

    case 'RECEIVE_DELETE_ACCOUNT_FAIL':
       return {
        ...state,
        tryingToDeleteAccount: false,
        failedToDeleteAccount: new Date().getTime(),
        deleteAccountForm: {errors: action.data.errors, lastSubmit: {}}
      }

    case 'RECEIVE_DELETE_ACCOUNT_SUCCESS':

      // Cookies.remove(process.env.REACT_APP_COOKIE_AUTH);
      window.location.replace('/');
      return {
        ...state,
        token: undefined,
        id: undefined,
        roles: {trial: true},
        employee: undefined,
        display_name: undefined,
        email: undefined,
        tryingToLogin: false,
        isLoggedIn: false,
        delinquent: false
      }



     case 'REQUEST_CONFIRM_EMAIL':
      return {
        ...state,
        tryingToConfirmEmail: true,
        confirmEmailLoginForm: {errors: {}, lastSubmit: action.data.lastSubmit}
      }

    case 'RECEIVE_CONFIRM_EMAIL_FAIL':
       return {
        ...state,
        tryingToConfirmEmail: false,
        confirmEmailLoginForm: {errors: action.data.errors, lastSubmit: action.data.lastSubmit}
      }

    case 'RECEIVE_CONFIRM_EMAIL_SUCCESS':

       Cookies.set(process.env.REACT_APP_COOKIE_AUTH, action.data.token);
      //  return {
      //   ...state,
      //   tryingToConfirmEmail: false,
      //   isLoggedIn: true,
      //   email: action.data.email,
      //   email_verified: action.data.email_verified
      //   // id: action.data.id,
        // teams: action.data.teams,
      //   // roles: action.data.roles,
      //   // employee: action.data.employee,
      //   // display_name: action.data.display_name,
      //   confirmEmailLoginForm: {errors: {}, lastSubmit: {}}
      // }

       parsed_token = JSON.parse(window.atob(action.data.token.split('.')[1]));

       return {
        ...state,
        tryingToConfirmEmail: false,
        isLoggedIn: true,
        email: parsed_token.email,
        email_verified: parsed_token.email_verified,
        confirmEmailLoginForm: {errors: {}, lastSubmit: {}}
      }



    case 'REQUEST_RESET_PASSWORD':
      return {
        ...state,
        tryingToResetPassword: true,
        resetPasswordForm: {errors: {}, lastSubmit: action.data.lastSubmit}
      }

    case 'RECEIVE_RESET_PASSWORD_FAIL':
       return {
        ...state,
        tryingToResetPassword: false,
        failedToResetPassword: new Date().getTime(),
        resetPasswordForm: {errors: action.data.errors, lastSubmit: action.data.lastSubmit}
      }

    case 'RECEIVE_RESET_PASSWORD_SUCCESS':

       return {
        ...state,
        tryingToResetPassword: false,
        successfullyResetPassword: new Date().getTime(),
        resetPasswordForm: {errors: {}, lastSubmit: action.data.lastSubmit}
      }



    // case 'REQUEST_USER_BILLING_STATUS':
    //   return {
    //     ...state,
    //     tryingToFetchUserBillingStatus: true
    //   }

    // case 'RECEIVE_USER_BILLING_STATUS_FAIL':
    //    return {
    //     ...state,
    //     tryingToFetchUserBillingStatus: false,
    //     billingStatus: action.data
    //   }

    // case 'RECEIVE_USER_BILLING_STATUS_SUCCESS':

    //    return {
    //     ...state,
    //     tryingToFetchUserBillingStatus: false,
    //     billingStatus: action.data
    //   }

    // case 'REQUEST_USER_INVOICE':
    //   return {
    //     ...state,
    //     tryingToFetchUserInvoice: true
    //   }

    // case 'RECEIVE_USER_INVOICE_FAIL':
    //    return {
    //     ...state,
    //     tryingToFetchUserInvoice: false,
    //     invoice: action.data
    //   }

    // case 'RECEIVE_USER_INVOICE_SUCCESS':

    //    return {
    //     ...state,
    //     tryingToFetchUserInvoice: false,
    //     invoice: action.data
    //   }



    // case 'REQUEST_PAST_USER_INVOICES':
    //   return {
    //     ...state,
    //     tryingToFetchPastUserInvoices: true,
    //     pastInvoices: []
    //   }

    // case 'RECEIVE_PAST_USER_INVOICES_FAIL':
    //    return {
    //     ...state,
    //     tryingToFetchPastUserInvoices: false,
    //     pastInvoices: []
    //   }

    // case 'RECEIVE_PAST_USER_INVOICES_SUCCESS':

    //    return {
    //     ...state,
    //     tryingToFetchPastUserInvoices: false,
    //     pastInvoices: action.data
    //   }



    // case 'REQUEST_USER_PAYMENT_METHODS':
    //   return {
    //     ...state,
    //     tryingToFetchUserPaymentMethods: true
    //   }

    // case 'RECEIVE_USER_PAYMENT_METHODS_FAIL':
    //    return {
    //     ...state,
    //     tryingToFetchUserPaymentMethods: false,
    //     paymentMethods: action.data
    //   }

    // case 'RECEIVE_USER_PAYMENT_METHODS_SUCCESS':

    //    return {
    //     ...state,
    //     tryingToFetchUserPaymentMethods: false,
    //     paymentMethods: action.data
    //   }


    // case 'REQUEST_ADD_PAYMENT_METHOD':
    //   return {
    //     ...state,
    //     tryingToAddPaymentMethod: true,
    //     paymentMethodsFormError: false,
    //     paymentMethodAddedSuccessfully: false
    //   }

    // case 'RECEIVE_ADD_PAYMENT_METHOD_FAIL':
    //    return {
    //     ...state,
    //     tryingToAddPaymentMethod: false,
    //     paymentMethodsFormError: action.data.errors,
    //     failedToAddPaymentMethod: new Date().getTime(),
    //     paymentMethodAddedSuccessfully: false
    //   }

    // case 'RECEIVE_ADD_PAYMENT_METHOD_SUCCESS':

    //    return {
    //     ...state,
    //     tryingToAddPaymentMethod: false,
    //     paymentMethodAddedSuccessfully: true,
    //     paymentMethodsFormError: false,
    //     successfullyAddedPaymentMethod: new Date().getTime(),
    //     paymentMethods: action.data
    //   }



    // case 'REQUEST_DELETE_PAYMENT_METHOD':
    //   return {
    //     ...state,
    //     tryingToDeletePaymentMethod: action.data.lastSubmit.card_id,
    //   }

    // case 'RECEIVE_DELETE_PAYMENT_METHOD_FAIL':
    //   return {
    //     ...state,
    //     tryingToDeletePaymentMethod: false
    //   }

    // case 'RECEIVE_DELETE_PAYMENT_METHOD_SUCCESS':

    //   var cards = state.paymentMethods;
    //   for(var i in cards){
    //     if(cards[i].id === state.tryingToDeletePaymentMethod){
    //       cards.splice(i, 1);
    //     }
    //   }

    //   return {
    //     ...state,
    //     paymentMethods: cards,
    //     tryingToDeletePaymentMethod: false
    //   }


    // case 'REQUEST_SET_DEFAULT_PAYMENT_METHOD':
    //   return {
    //     ...state,
    //     tryingToSetDefaultPaymentMethod: action.data.lastSubmit.card_id,
    //   }

    // case 'RECEIVE_SET_DEFAULT_PAYMENT_METHOD_FAIL':
    //   return {
    //     ...state,
    //     tryingToSetDefaultPaymentMethod: false
    //   }

    // case 'RECEIVE_SET_DEFAULT_PAYMENT_METHOD_SUCCESS':

    //   return {
    //     ...state,
    //     billingStatus: action.data,
    //     tryingToSetDefaultPaymentMethod: false
    //   }



    // case 'REQUEST_UPGRADE_TO_PRO':
    //   return {
    //     ...state,
    //     upgradeToProForm: {errors: {}, lastSubmit: {}},
    //     tryingToUpgradeToPro: true,
    //   }

    // case 'RECEIVE_UPGRADE_TO_PRO_FAIL':
    //    return {
    //     ...state,
    //     tryingToUpgradeToPro: false,
    //     upgradeToProForm: {errors: action.data.errors},
    //     failedToUpgradeToPro: new Date().getTime()
    //   }

    // case 'RECEIVE_UPGRADE_TO_PRO_SUCCESS':

    //    parsed_token = JSON.parse(window.atob(action.data.token.split('.')[1]));

    //    return {
    //     ...state,
    //     upgradeToProForm: {errors: {}, lastSubmit: {}},
    //     tryingToUpgradeToPro: false,
    //     successfullyUpgradedToPro: new Date().getTime(),
    //     isLoggedIn: true,
    //     email: parsed_token.email,
    //     public_email: action.data.public_email,
    //     id: parsed_token.id,
    //     teams: parsed_token.teams,
    //     roles: parsed_token.roles || {trial: true},
    //     employee: action.data.employee,
    //     display_name: parsed_token.display_name,
    //     delinquent: false
    //   }



    // case 'REQUEST_CANCEL_PRO':
    //   return {
    //     ...state,
    //     tryingToCancelPro: true,
    //     cancelProForm: {errors: {}, lastSubmit: action.data.lastSubmit}
    //   }

    // case 'RECEIVE_CANCEL_PRO_FAIL':
    //    return {
    //     ...state,
    //     tryingToCancelPro: false,
    //     failedToCancelPro: new Date().getTime(),
    //     cancelProForm: {errors: action.data.errors, lastSubmit: action.data.lastSubmit}
    //   }

    // case 'RECEIVE_CANCEL_PRO_SUCCESS':

    //    parsed_token = JSON.parse(window.atob(action.data.token.split('.')[1]));

    //    return {
    //     ...state,
    //     tryingToCancelPro: false,
    //     successfullyCanceledPro: new Date().getTime(),
    //     isLoggedIn: true,
    //     email: parsed_token.email,
    //     email_verified: parsed_token.email_verified,
    //     public_email: action.data.public_email,
    //     id: parsed_token.id,
    //     teams: parsed_token.teams,
    //     roles: parsed_token.roles || {trial: true},
    //     employee: action.data.employee,
    //     display_name: parsed_token.display_name,
    //     cancelProForm: {errors: {}, lastSubmit: {}},
    //     delinquent: false
    //   }




    case 'REQUEST_CREATE_USER_STRIPE_PORTAL_SESSION':
      return {
        ...state,
        tryingToCreateUserStripePortalSession: true,
        createUserStripePortalSessionForm: {errors: {}, lastSubmit: action.data.lastSubmit}
      }

    case 'RECEIVE_CREATE_USER_STRIPE_PORTAL_SESSION_FAIL':
      return {
        ...state,
        tryingToCreateUserStripePortalSession: false,
        failedToCreateUserStripePortalSession: new Date().getTime(),
        createUserStripePortalSessionForm: {errors: action.data.errors, lastSubmit: action.data.lastSubmit}
      }

    case 'RECEIVE_CREATE_USER_STRIPE_PORTAL_SESSION_SUCCESS':

      return {
        ...state,
        tryingToCreateUserStripePortalSession: false,
        successfullyCreatedUserStripePortalSession: new Date().getTime(),
        createUserStripePortalSessionForm: {errors: {}, lastSubmit: {}},
      }


    case 'REQUEST_CREATE_USER_STRIPE_CHECKOUT_SESSION':
      return {
        ...state,
        tryingToCreateUserStripeCheckoutSession: true,
        createUserStripeCheckoutSessionForm: {errors: {}, lastSubmit: action.data.lastSubmit}
      }

    case 'RECEIVE_CREATE_USER_STRIPE_CHECKOUT_SESSION_FAIL':
      return {
        ...state,
        tryingToCreateUserStripeCheckoutSession: false,
        failedToCreateUserStripeCheckoutSession: new Date().getTime(),
        createUserStripeCheckoutSessionForm: {errors: action.data.errors, lastSubmit: action.data.lastSubmit}
      }

    case 'RECEIVE_CREATE_USER_STRIPE_CHECKOUT_SESSION_SUCCESS':

      return {
        ...state,
        tryingToCreateUserStripeCheckoutSession: false,
        successfullyCreatedUserStripeCheckoutSession: new Date().getTime(),
        createUserStripeCheckoutSessionForm: {errors: {}, lastSubmit: {}},
      }



    case 'LOAD_TOKEN':
      var token = Cookies.get(process.env.REACT_APP_COOKIE_AUTH);
      // console.log(token);
      if(token){
        var parsed_token = JSON.parse(window.atob(token.split('.')[1]));
        // console.log('PARSED TOKEN', parsed_token);
        return {
          ...state, 
          token: token,
          id: parsed_token.id,
          teams: parsed_token.teams,
          roles: parsed_token.roles || {trial: true},
          employee: parsed_token.employee,
          display_name: parsed_token.display_name, 
          email: parsed_token.email,
          email_verified: parsed_token.email_verified,
          settings: parsed_token.settings || {},
          isLoggedIn: true
        }
      } 
      return state;

    default:
      var token = Cookies.get(process.env.REACT_APP_COOKIE_AUTH);
      if(token){
        try{
          var parsed_token = JSON.parse(window.atob(token.split('.')[1]));
          // console.log('PARSED TOKEN', parsed_token);
          return {
            ...state, 
            token: token,
            id: parsed_token.id,
            teams: parsed_token.teams,
            roles: parsed_token.roles || {trial: true},
            employee: parsed_token.employee,
            display_name: parsed_token.display_name, 
            email: parsed_token.email,
            email_verified: parsed_token.email_verified,
            settings: parsed_token.settings || {},
            isLoggedIn: true
          }
        } catch(e){
          console.log(e);
          return state;
        }
      } 
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/reducers.user.js